var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-simple-table',{scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('tbody',_vm._l((_vm.tableItems),function(item,idx){return _c('tr',{key:idx},[_c('td',[_vm._v(_vm._s(item.text))]),_c('td',[_vm._v(_vm._s(item.value))])])}),0)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }